import {
  DatasetTableConfig,
  dateColumn,
  TableConfigBuilder,
  textColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { IntelligenceModels } from '@models/intelligence.model';

type Dashboard = IntelligenceModels.Dashboards.ListItem;

export interface CreateDashboardsResultTableConfigDependencies {
  onRowClick: (dashboard: Dashboard) => void;
}

/**
 * Read-only Cmd+K dashboards result table — reuses the web Dashboards page column
 * labels (`DASHBOARD.TABLE.*`) but without the list page's edit/delete actions.
 * Row click drills into the dashboard detail overlay instead of navigating.
 */
export function createDashboardsResultTableConfig(
  dependencies: CreateDashboardsResultTableConfigDependencies,
): DatasetTableConfig<Dashboard> {
  return new TableConfigBuilder<Dashboard>()
    .columns([
      textColumn<Dashboard>('name', 'DASHBOARD.TABLE.NAME', {
        width: 'minmax(150px, 1fr)',
        mobileVisible: true,
      }),
      dateColumn<Dashboard>('updatedAt', 'DASHBOARD.TABLE.UPDATED', {
        width: 'minmax(180px, 1fr)',
        customFormat: 'YYYY MMM DD, hh:mm A',
        showTimeZone: true,
        mobileVisible: true,
      }),
    ])
    .trackBy('id')
    .rowHeight(52)
    .onRowClick(dependencies.onRowClick)
    .build();
}
